import { render, staticRenderFns } from "./detailKecelakaanDiri.vue?vue&type=template&id=d2b0d936&"
import script from "./detailKecelakaanDiri.vue?vue&type=script&lang=ts&"
export * from "./detailKecelakaanDiri.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports